<div class="info">
  <span class="glicon-alert-thin"> </span>
  <div class="info-panel">
    {{
      'distributors.expirationDateInfo'
        | translate : { seatsAmount: value.seatsAmount, expirationDate: value.expirationDate }
    }}
  </div>
</div>
